// /forgot-password
import { API } from "../../apiSlice";

export const checkOldPasswordApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    checkOldPassword: builder.mutation({
      query: (data) => {
        return {
          url: "users/check-old-password",
          method: "POST",
          body: data,
        };
      },
    }),
  }),
});

export const { useCheckOldPasswordMutation } = checkOldPasswordApiSlice;
